import React from "react";
import { Switch, FormControlLabel, TextField } from "@mui/material";

const TogglesAndMeta = ({ form, handleChange }) => {
  return (
    <>
      <FormControlLabel
        control={
          <Switch
            checked={form.enabled}
            onChange={(e) => handleChange("enabled", e.target.checked)}
          />
        }
        label="Enabled"
      />

      <FormControlLabel
        control={
          <Switch
            checked={form.autoApply}
            onChange={(e) => handleChange("autoApply", e.target.checked)}
          />
        }
        label="Auto Apply"
      />

      <TextField
        fullWidth
        label="Coupon Code"
        value={form.couponCode || ""}
        onChange={(e) => handleChange("couponCode", e.target.value)}
        sx={{ mt: 2 }}
      />
    </>
  );
};

export default TogglesAndMeta;
